import xe from "react";
import nr from "styled-components";
var X = { exports: {} }, D = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var z, je;
function Ce() {
  if (je) return z;
  je = 1;
  var g = Object.getOwnPropertySymbols, T = Object.prototype.hasOwnProperty, E = Object.prototype.propertyIsEnumerable;
  function P(R) {
    if (R == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(R);
  }
  function C() {
    try {
      if (!Object.assign)
        return !1;
      var R = new String("abc");
      if (R[5] = "de", Object.getOwnPropertyNames(R)[0] === "5")
        return !1;
      for (var O = {}, c = 0; c < 10; c++)
        O["_" + String.fromCharCode(c)] = c;
      var l = Object.getOwnPropertyNames(O).map(function(s) {
        return O[s];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(s) {
        p[s] = s;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return z = C() ? Object.assign : function(R, O) {
    for (var c, l = P(R), p, s = 1; s < arguments.length; s++) {
      c = Object(arguments[s]);
      for (var m in c)
        T.call(c, m) && (l[m] = c[m]);
      if (g) {
        p = g(c);
        for (var _ = 0; _ < p.length; _++)
          E.call(c, p[_]) && (l[p[_]] = c[p[_]]);
      }
    }
    return l;
  }, z;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Te;
function ar() {
  if (Te) return D;
  Te = 1, Ce();
  var g = xe, T = 60103;
  if (D.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var E = Symbol.for;
    T = E("react.element"), D.Fragment = E("react.fragment");
  }
  var P = g.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, C = Object.prototype.hasOwnProperty, R = { key: !0, ref: !0, __self: !0, __source: !0 };
  function O(c, l, p) {
    var s, m = {}, _ = null, x = null;
    p !== void 0 && (_ = "" + p), l.key !== void 0 && (_ = "" + l.key), l.ref !== void 0 && (x = l.ref);
    for (s in l) C.call(l, s) && !R.hasOwnProperty(s) && (m[s] = l[s]);
    if (c && c.defaultProps) for (s in l = c.defaultProps, l) m[s] === void 0 && (m[s] = l[s]);
    return { $$typeof: T, type: c, key: _, ref: x, props: m, _owner: P.current };
  }
  return D.jsx = O, D.jsxs = O, D;
}
var H = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pe;
function ir() {
  return Pe || (Pe = 1, function(g) {
    process.env.NODE_ENV !== "production" && function() {
      var T = xe, E = Ce(), P = 60103, C = 60106;
      g.Fragment = 60107;
      var R = 60108, O = 60114, c = 60109, l = 60110, p = 60112, s = 60113, m = 60120, _ = 60115, x = 60116, $ = 60121, Z = 60122, Q = 60117, ee = 60129, re = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var d = Symbol.for;
        P = d("react.element"), C = d("react.portal"), g.Fragment = d("react.fragment"), R = d("react.strict_mode"), O = d("react.profiler"), c = d("react.provider"), l = d("react.context"), p = d("react.forward_ref"), s = d("react.suspense"), m = d("react.suspense_list"), _ = d("react.memo"), x = d("react.lazy"), $ = d("react.block"), Z = d("react.server.block"), Q = d("react.fundamental"), d("react.scope"), d("react.opaque.id"), ee = d("react.debug_trace_mode"), d("react.offscreen"), re = d("react.legacy_hidden");
      }
      var te = typeof Symbol == "function" && Symbol.iterator, Se = "@@iterator";
      function Ae(e) {
        if (e === null || typeof e != "object")
          return null;
        var r = te && e[te] || e[Se];
        return typeof r == "function" ? r : null;
      }
      var S = T.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function b(e) {
        {
          for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
            t[n - 1] = arguments[n];
          ke("error", e, t);
        }
      }
      function ke(e, r, t) {
        {
          var n = S.ReactDebugCurrentFrame, u = n.getStackAddendum();
          u !== "" && (r += "%s", t = t.concat([u]));
          var o = t.map(function(i) {
            return "" + i;
          });
          o.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, o);
        }
      }
      var De = !1;
      function Ie(e) {
        return !!(typeof e == "string" || typeof e == "function" || e === g.Fragment || e === O || e === ee || e === R || e === s || e === m || e === re || De || typeof e == "object" && e !== null && (e.$$typeof === x || e.$$typeof === _ || e.$$typeof === c || e.$$typeof === l || e.$$typeof === p || e.$$typeof === Q || e.$$typeof === $ || e[0] === Z));
      }
      function Ye(e, r, t) {
        var n = r.displayName || r.name || "";
        return e.displayName || (n !== "" ? t + "(" + n + ")" : t);
      }
      function ne(e) {
        return e.displayName || "Context";
      }
      function y(e) {
        if (e == null)
          return null;
        if (typeof e.tag == "number" && b("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof e == "function")
          return e.displayName || e.name || null;
        if (typeof e == "string")
          return e;
        switch (e) {
          case g.Fragment:
            return "Fragment";
          case C:
            return "Portal";
          case O:
            return "Profiler";
          case R:
            return "StrictMode";
          case s:
            return "Suspense";
          case m:
            return "SuspenseList";
        }
        if (typeof e == "object")
          switch (e.$$typeof) {
            case l:
              var r = e;
              return ne(r) + ".Consumer";
            case c:
              var t = e;
              return ne(t._context) + ".Provider";
            case p:
              return Ye(e, e.render, "ForwardRef");
            case _:
              return y(e.type);
            case $:
              return y(e._render);
            case x: {
              var n = e, u = n._payload, o = n._init;
              try {
                return y(o(u));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var I = 0, ae, ie, oe, ue, se, ce, fe;
      function le() {
      }
      le.__reactDisabledLog = !0;
      function $e() {
        {
          if (I === 0) {
            ae = console.log, ie = console.info, oe = console.warn, ue = console.error, se = console.group, ce = console.groupCollapsed, fe = console.groupEnd;
            var e = {
              configurable: !0,
              enumerable: !0,
              value: le,
              writable: !0
            };
            Object.defineProperties(console, {
              info: e,
              log: e,
              warn: e,
              error: e,
              group: e,
              groupCollapsed: e,
              groupEnd: e
            });
          }
          I++;
        }
      }
      function We() {
        {
          if (I--, I === 0) {
            var e = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: E({}, e, {
                value: ae
              }),
              info: E({}, e, {
                value: ie
              }),
              warn: E({}, e, {
                value: oe
              }),
              error: E({}, e, {
                value: ue
              }),
              group: E({}, e, {
                value: se
              }),
              groupCollapsed: E({}, e, {
                value: ce
              }),
              groupEnd: E({}, e, {
                value: fe
              })
            });
          }
          I < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var V = S.ReactCurrentDispatcher, B;
      function W(e, r, t) {
        {
          if (B === void 0)
            try {
              throw Error();
            } catch (u) {
              var n = u.stack.trim().match(/\n( *(at )?)/);
              B = n && n[1] || "";
            }
          return `
` + B + e;
        }
      }
      var N = !1, L;
      {
        var Le = typeof WeakMap == "function" ? WeakMap : Map;
        L = new Le();
      }
      function de(e, r) {
        if (!e || N)
          return "";
        {
          var t = L.get(e);
          if (t !== void 0)
            return t;
        }
        var n;
        N = !0;
        var u = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var o;
        o = V.current, V.current = null, $e();
        try {
          if (r) {
            var i = function() {
              throw Error();
            };
            if (Object.defineProperty(i.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(i, []);
              } catch (j) {
                n = j;
              }
              Reflect.construct(e, [], i);
            } else {
              try {
                i.call();
              } catch (j) {
                n = j;
              }
              e.call(i.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (j) {
              n = j;
            }
            e();
          }
        } catch (j) {
          if (j && n && typeof j.stack == "string") {
            for (var a = j.stack.split(`
`), h = n.stack.split(`
`), f = a.length - 1, v = h.length - 1; f >= 1 && v >= 0 && a[f] !== h[v]; )
              v--;
            for (; f >= 1 && v >= 0; f--, v--)
              if (a[f] !== h[v]) {
                if (f !== 1 || v !== 1)
                  do
                    if (f--, v--, v < 0 || a[f] !== h[v]) {
                      var w = `
` + a[f].replace(" at new ", " at ");
                      return typeof e == "function" && L.set(e, w), w;
                    }
                  while (f >= 1 && v >= 0);
                break;
              }
          }
        } finally {
          N = !1, V.current = o, We(), Error.prepareStackTrace = u;
        }
        var k = e ? e.displayName || e.name : "", we = k ? W(k) : "";
        return typeof e == "function" && L.set(e, we), we;
      }
      function ve(e, r, t) {
        return de(e, !1);
      }
      function Fe(e) {
        var r = e.prototype;
        return !!(r && r.isReactComponent);
      }
      function F(e, r, t) {
        if (e == null)
          return "";
        if (typeof e == "function")
          return de(e, Fe(e));
        if (typeof e == "string")
          return W(e);
        switch (e) {
          case s:
            return W("Suspense");
          case m:
            return W("SuspenseList");
        }
        if (typeof e == "object")
          switch (e.$$typeof) {
            case p:
              return ve(e.render);
            case _:
              return F(e.type);
            case $:
              return ve(e._render);
            case x: {
              var n = e, u = n._payload, o = n._init;
              try {
                return F(o(u));
              } catch {
              }
            }
          }
        return "";
      }
      var pe = {}, ge = S.ReactDebugCurrentFrame;
      function U(e) {
        if (e) {
          var r = F(e.type);
          ge.setExtraStackFrame(r);
        } else
          ge.setExtraStackFrame(null);
      }
      function Ue(e, r, t, n, u) {
        {
          var o = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var i in e)
            if (o(e, i)) {
              var a = void 0;
              try {
                if (typeof e[i] != "function") {
                  var h = Error((n || "React class") + ": " + t + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[i] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw h.name = "Invariant Violation", h;
                }
                a = e[i](r, i, n, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (f) {
                a = f;
              }
              a && !(a instanceof Error) && (U(u), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n || "React class", t, i, typeof a), U(null)), a instanceof Error && !(a.message in pe) && (pe[a.message] = !0, U(u), b("Failed %s type: %s", t, a.message), U(null));
            }
        }
      }
      var Y = S.ReactCurrentOwner, M = Object.prototype.hasOwnProperty, Ve = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, _e, he, q;
      q = {};
      function Be(e) {
        if (M.call(e, "ref")) {
          var r = Object.getOwnPropertyDescriptor(e, "ref").get;
          if (r && r.isReactWarning)
            return !1;
        }
        return e.ref !== void 0;
      }
      function Ne(e) {
        if (M.call(e, "key")) {
          var r = Object.getOwnPropertyDescriptor(e, "key").get;
          if (r && r.isReactWarning)
            return !1;
        }
        return e.key !== void 0;
      }
      function Me(e, r) {
        if (typeof e.ref == "string" && Y.current && r && Y.current.stateNode !== r) {
          var t = y(Y.current.type);
          q[t] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', y(Y.current.type), e.ref), q[t] = !0);
        }
      }
      function qe(e, r) {
        {
          var t = function() {
            _e || (_e = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
          };
          t.isReactWarning = !0, Object.defineProperty(e, "key", {
            get: t,
            configurable: !0
          });
        }
      }
      function Ge(e, r) {
        {
          var t = function() {
            he || (he = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
          };
          t.isReactWarning = !0, Object.defineProperty(e, "ref", {
            get: t,
            configurable: !0
          });
        }
      }
      var Je = function(e, r, t, n, u, o, i) {
        var a = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: P,
          // Built-in properties that belong on the element
          type: e,
          key: r,
          ref: t,
          props: i,
          // Record the component responsible for creating this element.
          _owner: o
        };
        return a._store = {}, Object.defineProperty(a._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(a, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: n
        }), Object.defineProperty(a, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: u
        }), Object.freeze && (Object.freeze(a.props), Object.freeze(a)), a;
      };
      function Ke(e, r, t, n, u) {
        {
          var o, i = {}, a = null, h = null;
          t !== void 0 && (a = "" + t), Ne(r) && (a = "" + r.key), Be(r) && (h = r.ref, Me(r, u));
          for (o in r)
            M.call(r, o) && !Ve.hasOwnProperty(o) && (i[o] = r[o]);
          if (e && e.defaultProps) {
            var f = e.defaultProps;
            for (o in f)
              i[o] === void 0 && (i[o] = f[o]);
          }
          if (a || h) {
            var v = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
            a && qe(i, v), h && Ge(i, v);
          }
          return Je(e, a, h, u, n, Y.current, i);
        }
      }
      var G = S.ReactCurrentOwner, Ee = S.ReactDebugCurrentFrame;
      function A(e) {
        if (e) {
          var r = F(e.type);
          Ee.setExtraStackFrame(r);
        } else
          Ee.setExtraStackFrame(null);
      }
      var J;
      J = !1;
      function K(e) {
        return typeof e == "object" && e !== null && e.$$typeof === P;
      }
      function Re() {
        {
          if (G.current) {
            var e = y(G.current.type);
            if (e)
              return `

Check the render method of \`` + e + "`.";
          }
          return "";
        }
      }
      function ze(e) {
        return "";
      }
      var be = {};
      function He(e) {
        {
          var r = Re();
          if (!r) {
            var t = typeof e == "string" ? e : e.displayName || e.name;
            t && (r = `

Check the top-level render call using <` + t + ">.");
          }
          return r;
        }
      }
      function me(e, r) {
        {
          if (!e._store || e._store.validated || e.key != null)
            return;
          e._store.validated = !0;
          var t = He(r);
          if (be[t])
            return;
          be[t] = !0;
          var n = "";
          e && e._owner && e._owner !== G.current && (n = " It was passed a child from " + y(e._owner.type) + "."), A(e), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, n), A(null);
        }
      }
      function Oe(e, r) {
        {
          if (typeof e != "object")
            return;
          if (Array.isArray(e))
            for (var t = 0; t < e.length; t++) {
              var n = e[t];
              K(n) && me(n, r);
            }
          else if (K(e))
            e._store && (e._store.validated = !0);
          else if (e) {
            var u = Ae(e);
            if (typeof u == "function" && u !== e.entries)
              for (var o = u.call(e), i; !(i = o.next()).done; )
                K(i.value) && me(i.value, r);
          }
        }
      }
      function Xe(e) {
        {
          var r = e.type;
          if (r == null || typeof r == "string")
            return;
          var t;
          if (typeof r == "function")
            t = r.propTypes;
          else if (typeof r == "object" && (r.$$typeof === p || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          r.$$typeof === _))
            t = r.propTypes;
          else
            return;
          if (t) {
            var n = y(r);
            Ue(t, e.props, "prop", n, e);
          } else if (r.PropTypes !== void 0 && !J) {
            J = !0;
            var u = y(r);
            b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", u || "Unknown");
          }
          typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Ze(e) {
        {
          for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
            var n = r[t];
            if (n !== "children" && n !== "key") {
              A(e), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n), A(null);
              break;
            }
          }
          e.ref !== null && (A(e), b("Invalid attribute `ref` supplied to `React.Fragment`."), A(null));
        }
      }
      function ye(e, r, t, n, u, o) {
        {
          var i = Ie(e);
          if (!i) {
            var a = "";
            (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (a += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var h = ze();
            h ? a += h : a += Re();
            var f;
            e === null ? f = "null" : Array.isArray(e) ? f = "array" : e !== void 0 && e.$$typeof === P ? (f = "<" + (y(e.type) || "Unknown") + " />", a = " Did you accidentally export a JSX literal instead of a component?") : f = typeof e, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", f, a);
          }
          var v = Ke(e, r, t, u, o);
          if (v == null)
            return v;
          if (i) {
            var w = r.children;
            if (w !== void 0)
              if (n)
                if (Array.isArray(w)) {
                  for (var k = 0; k < w.length; k++)
                    Oe(w[k], e);
                  Object.freeze && Object.freeze(w);
                } else
                  b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Oe(w, e);
          }
          return e === g.Fragment ? Ze(v) : Xe(v), v;
        }
      }
      function Qe(e, r, t) {
        return ye(e, r, t, !0);
      }
      function er(e, r, t) {
        return ye(e, r, t, !1);
      }
      var rr = er, tr = Qe;
      g.jsx = rr, g.jsxs = tr;
    }();
  }(H)), H;
}
process.env.NODE_ENV === "production" ? X.exports = ar() : X.exports = ir();
var or = X.exports;
const ur = nr("span")`
  svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`, sr = ({
  svg: g = '<svg width="20" height="20">test</svg>',
  ...T
}) => {
  const E = document.createElement("div");
  return E.innerHTML = g, /* @__PURE__ */ or.jsx(
    ur,
    {
      ...T,
      "data-cy": "BaseIcon",
      dangerouslySetInnerHTML: { __html: g }
    }
  );
};
sr.displayName = "BaseIcon";
export {
  sr as B,
  ur as a,
  or as j
};
